import { useMemo } from 'react';

import setRef from '../setRef/index.ts';

export default function useForkRef<T>(
  refA: ((instance: T | null) => void) | React.MutableRefObject<T> | null,
  refB: ((instance: T | null) => void) | React.MutableRefObject<T> | null
): ((setTo: T) => void) | null {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return useMemo(() => {
    if (refA == null && refB == null) {
      return null;
    }

    return refValue => {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}

// From https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/utils/useForkRef.js
